import { parseTemplate } from 'url-template';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import AeMaxPrice from './AeMaxPrice';
import ErrorResponse from './ErrorResponse';
import mapAeMaxPrice from './mapAeMaxPrice';

export interface Result {
	aeMaxPrice: AeMaxPrice;
}

export default async function findAeMaxPrice(client: ApiClient, userId: string, groupId: string): Promise<Result> {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/ae-max-price');

	try {
		const request = await client.fetch(url.expand({ userId, groupId }));
		const response = await request.json();
		return { aeMaxPrice: mapAeMaxPrice(response.aeMaxPrice) };
	} catch (error) {
		throw error instanceof ApiClientErrorResponse
			? new ErrorResponse(error.request, error.statusCode, error.errors)
			: error;
	}
}
